<script setup lang="ts">
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import { myRequest } from '@/utils/fetch'

const route = useRoute()
const confirm = ref(false)
const teamName = ref('')
const inviteID = route.query.inviteID as string

const getInvitationInfo = async () => {
  if (!inviteID) {
    confirm.value = true
    return
  }
  const { name } = await myRequest('GET', `/teams/getInvitation/${inviteID}`)
  teamName.value = name
  confirm.value = true
}

const acceptInvitation = async () => {
  await myRequest('POST', '/teams/acceptInvitation', { inviteID })
  goToHome()
}

const goToHome = () => {
  window.location.href = '/'
}

getInvitationInfo()
</script>

<template>
  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section>
        <h5>You are invited to join {{ teamName }}</h5>
        <span>Joining the team will cancel your current subscription!</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Ignore" color="primary" v-close-popup @click="goToHome" />
        <q-btn :disable="!teamName" flat label="Accept" color="primary" v-close-popup @click="acceptInvitation" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
